import { ITracking } from 'api/types/_tracking';
import { CONFIG_OPTION_TOAST_ERROR } from 'common/toast';
import CopyWrapper from 'components/Common/CopyWrapper';
import DropdownMultiOption from 'components/Common/DropdownMultiOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useDurationResponses } from 'components/Hooks/DurationResponsesHooks';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { AD_TYPE_INVENTORY_OPTIONS, AD_TYPE_OPTIONS, BROWSER_OPTIONS, CLICK_TYPE_AUTO_POPUP, CLICK_TYPE_AUTO_REDIRECT, CLICK_TYPE_FORCE, CLICK_TYPE_NORMAL, CLICK_TYPE_OPTIONS, DEVICE_OPTIONS, IS_OPTIONS, OS_OPTIONS, PLATFORM_LOG_OPTIONS, TYPE_NEWS_OPTIONS } from 'helpers/constans';
import { formatLinkHTTPS, renderUrlSearchLookingUpByIP } from 'helpers/format';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from "react-countup";
import DatePicker, { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import iconBlock from "../../../assets/images/icon-block.png";
import iconExcept from "../../../assets/images/icon-except.png";
import type_auto from "../../../assets/images/type_auto.png";
import type_normal from "../../../assets/images/type_normal.png";
import type_redirect from "../../../assets/images/type_redirect.png";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import CollapseFilter from '../../../components/Common/CollapseFilter';
import DropdownOption from '../../../components/Common/DropdownOption';
import TableContainer from "../../../components/Common/TableContainer";
import { getAllMedias, getTrackingLogsByNormal } from "../../../store/thunks";
import TableTracking from '../TableTracking';


interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

registerLocale('en', en);
registerLocale('ko', ko);

const TYPE_SELECT_DEFAULT: string = 'created_at';
const ORDER_BY_DEFAULT = 'DESC';


const ICONS = {
  'is_except_ip': iconExcept,
  'is_except_ip_timer': iconExcept,
  'is_block_ip': iconBlock,
  'is_normal': type_normal,
  'is_except_uuid': iconExcept,
  'is_block_uuid': iconBlock,
};

const TrackingLog = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();
  const { durationResponses, setDurationResponses } = useDurationResponses();

  const isFirstLoadingPageRef = useRef<any>(true);

  const PLATFORM_LOG_OPTIONS_LANG = PLATFORM_LOG_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  //const AD_PLATFORM_LOG_OPTIONS_LANG = AD_PLATFORM_LOG_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const AD_TYPE_OPTIONS_LANG = AD_TYPE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  //const MONITOR_TYPE_OPTIONS_LANG = MONITOR_TYPE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const CLICK_TYPE_OPTIONS_LANG = CLICK_TYPE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const DEVICE_OPTIONS_LANG = DEVICE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  //const BOT_OPTIONS_LANG = BOT_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const BROWSER_OPTIONS_LANG = BROWSER_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const OS_OPTIONS_LANG = OS_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const TYPE_NEWS_OPTIONS_LANG = TYPE_NEWS_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const IS_OPTIONS_LANG = IS_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  // const REFERRAL_TYPE_OPTIONS_LANG = REFERRAL_TYPE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  // const VERSION_OPTIONS_LANG = VERSION_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) })) || [];

  const AD_TYPE_INVENTORY_OPTIONS_LANG = AD_TYPE_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  // const POSITION_INVENTORY_OPTIONS_LANG = POSITION_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  // const AD_PLATFORM_INVENTORY_OPTIONS_LANG = AD_PLATFORM_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const TIME_OPTION_LANG = [{ label: "00:00", value: "0" },
  { label: "01:00", value: "1" }, { label: "02:00", value: "2" }, { label: "03:00", value: "3" }, { label: "04:00", value: "4" }, { label: "05:00", value: "5" },
  { label: "06:00", value: "6" }, { label: "07:00", value: "7" }, { label: "08:00", value: "8" }, { label: "09:00", value: "9" }, { label: "10:00", value: "10" },
  { label: "11:00", value: "11" }, { label: "12:00", value: "12" }, { label: "13:00", value: "13" }, { label: "14:00", value: "14" }, { label: "15:00", value: "15" },
  { label: "16:00", value: "16" }, { label: "17:00", value: "17" }, { label: "18:00", value: "18" }, { label: "19:00", value: "19" }, { label: "20:00", value: "20" },
  { label: "21:00", value: "21" }, { label: "22:00", value: "22" }, { label: "23:00", value: "23" }]?.map((item: any) => ({ value: item?.value, label: item?.label }));

  // const TYPE_MEDIA_OPTIONS_LANG = TYPE_MEDIA_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
    media_id: withDefault(StringParam, ''),
    title: withDefault(StringParam, ''),
    reference_link: withDefault(StringParam, ''),
    // tracking_code: withDefault(StringParam, ''),
    ip: withDefault(StringParam, ''),
    og_url: withDefault(StringParam, ''),
    keyword: withDefault(StringParam, ''),
    uuid: withDefault(StringParam, ''),
    start_date: withDefault(StringParam, moment(new Date()).format("Y-MM-DD")),
    end_date: withDefault(StringParam, moment(new Date()).format("Y-MM-DD")),
    platform: withDefault(StringParam, ''),
    // ad_platform: withDefault(StringParam, ''),
    ad_type: withDefault(StringParam, ''),
    // add_type: withDefault(StringParam, ''),
    // inventory_ad_type: withDefault(StringParam, ''),
    // click_type: withDefault(StringParam, ''),
    // inventory_type_id: withDefault(StringParam, AD_TYPE_INVENTORY_IS_FIXED_BANNER),
    device: withDefault(StringParam, ''),
    browser: withDefault(StringParam, ''),
    os: withDefault(StringParam, ''),
    // inventory_code: withDefault(StringParam, ''),
    // bot: withDefault(StringParam, '0'),
    // referral_type: withDefault(StringParam, ''),
    // script_version: withDefault(StringParam, ''),
    // banner_size: withDefault(StringParam, ''),
    hour: withDefault(StringParam, ''),
    // sub_id: withDefault(StringParam, ''),
    // ad_id: withDefault(StringParam, ''),
    // duid: withDefault(StringParam, ''),
    device_id: withDefault(StringParam, ''),
    // is_except_uuid: withDefault(NumberParam, null),
    // is_block_uuid: withDefault(NumberParam, null),
    // is_except_ip: withDefault(NumberParam, null),
    // is_block_ip: withDefault(NumberParam, null),
    // is_except_ip_timer: withDefault(NumberParam, null),
    // is_normal: withDefault(NumberParam, null),
    // cdn_domain: withDefault(StringParam, ''),
  });

  const [subIdSearch, setSubIdSearch] = useState<string>(query?.sub_id || "");

  const [adIdSearch, setAdIdSearch] = useState<string>(query?.ad_id || "");

  const [dateSearch, setDateSearch] = useState<string>(query?.start_date || "");

  const [referenceLinkSearch, setReferenceLinkSearch] = useState<string>(query?.reference_link || "");

  const [ipSearch, setIpSearch] = useState<string>(query?.ip || "");

  const [trackingCodeSearch, setTrackingCodeSearch] = useState<string>(query?.tracking_code || "");

  const [urlSearch, setUrlSearch] = useState<string>(query?.og_url || "");

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

  const [uuidSearch, setUuidSearch] = useState<string>(query?.uuid || "");

  const [bannerSizeSearch, setBannerSizeSearch] = useState<string>(query?.banner_size || "");

  const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");

  const [listMedia, setListMedia] = useState<any[]>([]);

  const [listInventory, setListInventory] = useState<any[]>([]);

  const [listDomain, setListDomain] = useState<any[]>([]);

  const [mediaSearch, setMediaSearch] = useState<Option[] | null>(null);

  // const [platformSearch, setPlatformSearch] = useState<Option[] | null>(PLATFORM_LOG_OPTIONS_LANG?.filter((item: any) => String(query?.platform).split(',')?.includes(String(item?.value))));

  // const [adPlatformSearch, setAdPlatformSearch] = useState<Option[] | null>(AD_PLATFORM_INVENTORY_OPTIONS_LANG?.filter((item: any) => String(query?.ad_platform).split(',')?.includes(String(item?.value))));

  // const [addTypeSearch, setAddTypeSearch] = useState<Option[] | null>(TYPE_MEDIA_OPTIONS_LANG?.filter((item: any) => String(query?.add_type).split(',')?.includes(String(item?.value))));

  const [adTypeSearch, setAdTypeSearch] = useState<Option[] | null>(AD_TYPE_OPTIONS_LANG?.filter((item: any) => String(query?.ad_type).split(',')?.includes(String(item?.value))));

  // const [adTypeInventorySearch, setAdTypeInventorySearch] = useState<Option[] | null>(AD_TYPE_INVENTORY_OPTIONS_LANG?.filter((item: any) => String(query?.inventory_ad_type).split(',')?.includes(String(item?.value))));

  // const [clickTypeSearch, setClickTypeSearch] = useState<Option[] | null>(CLICK_TYPE_OPTIONS_LANG?.filter((item: any) => String(query?.click_type).split(',')?.includes(String(item?.value))));

  const [deviceSearch, setDeviceSearch] = useState<Option[] | null>(DEVICE_OPTIONS_LANG?.filter((item: any) => String(query?.device).split(',')?.includes(String(item?.value))));

  //const [botSearch, setBotSearch] = useState<Option[] | null>(BOT_OPTIONS_LANG?.filter((item: any) => String(query?.bot).split(',')?.includes(String(item?.value))));

  const [browserSearch, setBrowserSearch] = useState<Option[] | null>(BROWSER_OPTIONS_LANG?.filter((item: any) => String(query?.browser).split(',')?.includes(String(item?.value))));

  // const [referralTypeSearch, setReferralTypeSearch] = useState<Option[] | null>(REFERRAL_TYPE_OPTIONS_LANG?.filter((item: any) => String(query?.referral_type).split(',')?.includes(String(item?.value))));

  // const [versionSearch, setVersionSearch] = useState<Option[] | null>(VERSION_OPTIONS_LANG?.filter((item: any) => String(query?.script_version).split(',')?.includes(String(item?.value))));

  const [osSearch, setOsSearch] = useState<Option[] | null>(OS_OPTIONS_LANG?.filter((item: any) => String(query?.os).split(',')?.includes(String(item?.value))));

  const [previewTrackingLog, setPreviewTrackingLog] = useState<ITracking | null>(null);

  const [isLoadingExportFile, setIsLoadingExportFile] = useState<boolean>(false);

  const [timeSearch, setTimeSearch] = useState<Option | null>(TIME_OPTION_LANG?.find((item: any) => String(query?.hour) === (String(item?.value))) || null);

  const [duidSearch, setDuidSearch] = useState<string>(query?.duid || "");

  const [deviceIdSearch, setDeviceIdSearch] = useState<string>(query?.device_id || "");

  const [typeInventorySearch, setTypeInventorySearch] = useState<Option[]>([]);

  const monitorTypeQ = {
    is_except_uuid: query?.is_except_uuid,
    is_block_uuid: query?.is_block_uuid,
    is_except_ip: query?.is_except_ip,
    is_block_ip: query?.is_block_ip,
    is_except_ip_timer: query?.is_except_ip_timer,
    is_normal: query?.is_normal,
  };
  // const [monitorTypeSearch, setMonitorTypeSearch] = useState<Option[] | null>(
  //   MONITOR_TYPE_OPTIONS_LANG?.filter((item: any) => String(monitorTypeQ[item?.value as keyof typeof monitorTypeQ]) === '1')
  // );

  const [listTypeInventory, setListTypeInventory] = useState<any[]>([]);

  // Inside your component

  const [trackingLogs, setTrackingLogs] = useState<{ list: ITracking[], total: number }>({ list: [], total: 0 });

  const [isCallAllOptionLoading, setIsCallAllOptionLoading] = useState<boolean>(true);

  const [isTrackingLogLoading, setIsTrackingLogLoading] = useState<boolean>(false);

  const [summariesLogs, setSummariesLogs] = useState<{ pv: number, uv: number, impression: number, click: number, uuid_uv: number }>({ uv: 0, pv: 0, impression: 0, click: 0, uuid_uv: 0 });
  const [isSummariesLogLoading, setIsSummariesLogLoading] = useState<boolean>(false);

  const handleQueryData = async () => {
    try {
      setIsTrackingLogLoading((prev) => true);
      const res: any = await getTrackingLogsByNormal(query);
      setTrackingLogs((prev: any) => ({
        list: Number(query?.page) === 1 ? (res?.data?.list || []) : (prev?.list || []).concat(res?.data?.list || []),
        total: res?.data?.pagination?.total || 0,
      }));
      setIsTrackingLogLoading((prev) => false);
      setDurationResponses([{
        name: 'Log',
        time: res?.data?.pagination?.duration || 0
      }]);
    } catch (error: any) {
      setIsTrackingLogLoading((prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
    }
  };

  const handleLoadMore = () => {
    setQuery({
      ...query,
      page: query?.page + 1
    });
  }

  useEffect(() => {
    if (!isFirstLoadingPageRef?.current) {
      handleQueryData();
      // (query?.page === 1) && handleQuerySummariesData();
    }
  }, [JSON.stringify(query)]);

  const searchData = () => {
    isFirstLoadingPageRef.current = false;
    const search_medias = mediaSearch?.map((m: any) => String(m?.value)) || [];
    const queryNew = {
      ...query,
      title: titleSearch || "",
      reference_link: encodeURIComponent(referenceLinkSearch) || "",
      // tracking_code: trackingCodeSearch || '',
      ip: ipSearch || "",
      og_url: encodeURIComponent(urlSearch) || '',
      keyword: keywordSearch || "",
      uuid: uuidSearch || "",
      // banner_size: bannerSizeSearch || "",
      media_id: search_medias.join(','),
      // platform: platformSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // ad_platform: adPlatformSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      ad_type: adTypeSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // add_type: addTypeSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // inventory_ad_type: adTypeInventorySearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      device: deviceSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // bot: botSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      browser: browserSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      os: osSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // referral_type: referralTypeSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // script_version: versionSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // click_type: clickTypeSearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      // inventory_type_id: typeInventorySearch?.reduce((arr: string[], item: Option) => (!!item?.value ? [...arr, item?.value] : arr), []).join(',') || '',
      hour: timeSearch?.value ?? '',
      sub_id: subIdSearch ?? '',
      ad_id: adIdSearch ?? '',
      duid: duidSearch ?? '',
      device_id: deviceIdSearch ?? '',
      start_date: dateSearch || '',
      end_date: dateSearch || '',
      // is_except_uuid: monitorTypeSearch?.find((item) => item?.value === 'is_except_uuid') ? 1 : null,
      // is_block_uuid: monitorTypeSearch?.find((item) => item?.value === 'is_block_uuid') ? 1 : null,
      // is_except_ip: monitorTypeSearch?.find((item) => item?.value === 'is_except_ip') ? 1 : null,
      // is_block_ip: monitorTypeSearch?.find((item) => item?.value === 'is_block_ip') ? 1 : null,
      // is_except_ip_timer: monitorTypeSearch?.find((item) => item?.value === 'is_except_ip_timer') ? 1 : null,
      // is_normal: monitorTypeSearch?.find((item) => item?.value === 'is_normal') ? 1 : null,
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: + new Date()
    };

    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setTrackingLogs((prev: any) => ({
        list: [],
        total: 0,
      }));
      setSummariesLogs((prev: any) => ({
        pv: 0,
        uv: 0,
        impression: 0,
        click: 0,
        uuid_uv: 0,
      }));
    }
    setQuery(queryNew);
  };

  const resetData = () => {
    isFirstLoadingPageRef.current = false;
    const queryNew = {
      ...query,
      title: '',
      reference_link: '',
      tracking_code: '',
      ip: '',
      og_url: '',
      keyword: '',
      uuid: '',
      banner_size: '',
      media_id: '',
      // cdn_domain: '',
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: ORDER_BY_DEFAULT,
      start_date: moment(new Date()).format("Y-MM-DD"),
      end_date: moment(new Date()).format("Y-MM-DD"),
      // platform: '',
      // ad_platform: '',
      ad_type: '',
      // add_type: '',
      // inventory_ad_type: '',
      // click_type: '',
      // inventory_type_id: AD_TYPE_INVENTORY_IS_FIXED_BANNER,
      device: '',
      bot: '0',
      browser: '',
      referral_type: '',
      // script_version: '',
      os: '',
      // inventory_code: '',
      hour: '',
      // sub_id: '',
      // ad_id: '',
      // duid: '',
      device_id: '',
      // is_except_uuid: null,
      // is_block_uuid: null,
      // is_except_ip: null,
      // is_block_ip: null,
      // is_except_ip_timer: null,
      // is_normal: null,
      page: 1,
      time_request: + new Date()
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setTrackingLogs((prev: any) => ({
        list: [],
        total: 0,
      }));
      setSummariesLogs((prev: any) => ({
        pv: 0,
        uv: 0,
        impression: 0,
        click: 0,
        uuid_uv: 0,
      }));
    }
    setQuery(queryNew, "push");
    setReferenceLinkSearch((_prev) => "");
    setIpSearch((_prev) => "");
    setUrlSearch((_prev) => "");
    setKeywordSearch((_prev) => "");
    setUuidSearch((prev) => "");
    // setBannerSizeSearch((prev) => "");
    setTitleSearch((_prev) => "");
    // setTrackingCodeSearch((_prev) => "");
    // setSubIdSearch((_prev) => "");
    // setAdIdSearch((_prev) => "");
    setMediaSearch(null);
    setDateSearch(moment(new Date()).format("Y-MM-DD"));
    // setPlatformSearch(null);
    // setAdPlatformSearch(null);
    setAdTypeSearch(null);
    // setAddTypeSearch(null);
    // setDeviceSearch(null);
    // setBotSearch([BOT_OPTIONS_LANG[0]]);
    setBrowserSearch(null);
    setOsSearch(null);
    // setReferralTypeSearch(null);
    // setVersionSearch(null);
    // setAdTypeInventorySearch(null);
    // setClickTypeSearch(null);
    setTimeSearch(null);
    setDuidSearch((_prev) => "");
    setDeviceIdSearch((_prev) => "");
    // setMonitorTypeSearch(null);
    setTypeInventorySearch((_prev) => {
      const items = listTypeInventory?.filter((item: any) => String(queryNew?.inventory_type_id || '')?.split(',')?.includes(String(item?.id || ''))) || [];
      return items?.map((item: any) => ({
        label: item?.title || '',
        value: `${item?.id || ''}`
      }))
    });
  };

  function onClosePreviewTrackingLogClick() {
    setPreviewTrackingLog((_prev) => null);
  }

  const handlePreviewTrackingLog = async (TrackingLog: ITracking | null = null) => {
    try {
      setPreviewTrackingLog((_prev) => TrackingLog);
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const decodeURI = (URIString: string = '') => {
    try {
      const decodedURI = decodeURIComponent(URIString);
      return decodedURI;
    } catch (e) {
      return URIString;
      // if (e instanceof URIError) {
      //   console.error('URIError: URI malformed');
      // } else {
      //   throw e;
      // }
    }
  }

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('WEB_ad_type'),
        accessor: "ad_type",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: 'text-center',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div className="text-center" style={{ minWidth: '70px' }}>
                {AD_TYPE_OPTIONS_LANG?.filter((el) => (!!cell?.value && String(el?.value) === String(cell?.value)))[0]?.label || cell?.value}
                {!!item?.click_type && <div className="d-flex justify-content-center align-items-center mt-1">
                  <img src={[CLICK_TYPE_AUTO_POPUP, CLICK_TYPE_FORCE]?.includes(item?.click_type) ? type_auto : ([CLICK_TYPE_NORMAL]?.includes(item?.click_type) ? type_normal : ([CLICK_TYPE_AUTO_REDIRECT]?.includes(item?.click_type) ? type_redirect : ''))} alt="type click" height="16" className="me-1" />
                  <span className="text-muted">{CLICK_TYPE_OPTIONS_LANG?.find((op) => String(op?.value) === String(item?.click_type))?.label || ''}</span>
                </div>}
                {/* <GenderMonitorTypeIcon
                  isBlockUUID={item?.is_block_uuid}
                  isExceptUUID={item?.is_except_uuid}
                  isBlockIP={item?.is_block_ip}
                  isExceptIP={item?.is_except_ip}
                  isExceptIPTimer={item?.is_except_ip_timer}
                /> */}
              </div>
            </>
          )
        },
      },
      {
        Header: t('Title Post'),
        accessor: "title",
        filterable: true,
        sortable: false,
        thWidth: 360,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '330px', maxWidth: '350px' }}>
              <div className="mb-2">
                <CopyWrapper contentCopy={item?.og_title}>
                  <Link className='text-normal' to={item?.og_url} target="_blank">
                    {item?.og_title}
                  </Link>
                </CopyWrapper>
              </div>

              <div className="d-flex flex-column mb-2">
                <span className="text-dark me-2 flex-shrink-0 text-muted fs-12">{t('Url')}: </span>
                <CopyWrapper contentCopy={item?.domain_url}>
                  <Link className='text-normal text-break' to={item?.domain_url} target="_blank">
                    {decodeURI(item?.domain_url || '')}
                  </Link>
                </CopyWrapper>
              </div>

              {!!item?.reference_link ? <div className="d-flex flex-column mb-2">
                <span className="text-dark me-2 flex-shrink-0 text-muted fs-12">{t('WEB_reference_link')}: </span>
                <CopyWrapper contentCopy={item?.reference_link || ''}>
                  <Link className='text-normal text-break' to={item?.reference_link} target="_blank">
                    {decodeURI(item?.reference_link || '')}
                  </Link>
                </CopyWrapper>
              </div> : <></>}

              {!!item?.uuid ? <div className="d-flex flex-column mb-2">
                <span className="text-dark me-2 flex-shrink-0 text-muted fs-12">{t('WEB_uuid')}: </span>
                <CopyWrapper contentCopy={item?.uuid || ''}>
                  {item?.is_block_uuid ? <img src={iconBlock} alt="block" height="16" className="me-1" style={{ borderRadius: '2px' }} /> : <></>}
                  {item?.is_except_uuid ? <img src={iconExcept} alt="except" height="16" className="me-1" style={{ borderRadius: '2px' }} /> : <></>}
                  {item?.uuid || ''}
                </CopyWrapper>
              </div> : <></>}

              {!!item?.duid ? <div className="d-flex flex-column mb-2">
                <span className="text-dark me-2 flex-shrink-0 text-muted fs-12">{t('WEB_duid')}: </span>
                <CopyWrapper contentCopy={item?.duid || ''}>
                  {item?.duid || ''}
                </CopyWrapper>
              </div> : <></>}

              {!!item?.device_id ? <div className="d-flex flex-column mb-2">
                <span className="text-dark me-2 flex-shrink-0 text-muted fs-12">{t('WEB_device_id')}: </span>
                <CopyWrapper contentCopy={item?.device_id || ''}>
                  {item?.device_id || ''}
                </CopyWrapper>
              </div> : <></>}

              {!!item?.ip ? <div className="d-flex flex-column">
                <span className="text-dark me-2 flex-shrink-0 text-muted fs-12">{t('IP')}: </span>
                <CopyWrapper contentCopy={item?.ip} style={{ display: 'flex', }}>
                  <Link className='text-normal d-flex align-items-center' to={renderUrlSearchLookingUpByIP(item?.ip)} target="_blank">
                    {item?.is_block_ip ? <img src={iconBlock} alt="block" height="16" className="me-1" style={{ borderRadius: '2px' }} /> : <></>}
                    {(item?.is_except_ip || item?.is_except_ip_timer) ? <img src={iconExcept} alt="except" height="16" className="me-1" style={{ borderRadius: '2px' }} /> : <></>}
                    {item?.ip}
                  </Link>
                </CopyWrapper>
              </div> : <></>}
            </div>
          </>)
        },
      },
      // {
      //   Header: t('Referral Type'),
      //   accessor: "referral_type",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 120,
      //   thClass: 'text-center',
      //   Cell: (cell: any) => (
      //     <>
      //       <div className="text-center" style={{ minWidth: '100px' }}>{REFERRAL_TYPE_OPTIONS_LANG?.filter((item) => (!!cell?.value && String(item?.value) === String(cell?.value)))[0]?.label || cell?.value}</div>
      //     </>
      //   ),
      // },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: false,
        thWidth: 130,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: '130px' }}>
            <CopyWrapper contentCopy={cell?.value}>
              {cell?.value || '-'}
            </CopyWrapper>
          </div>)
        },
      },
      {
        Header: t('Media'),
        accessor: "domain",
        filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const media: any = item?.media || {};
          return (<>
            <div className="d-flex align-items-center" style={{ width: '150px' }}>
              <div>
                <div>
                  {media?.name || ''}<span className="fs-12 text-muted ms-1">{!!media?.add_type ? `| ${t(`MEDIA_TYPE_${media?.add_type}`)}` : ''}</span>
                </div>
                <Link className='text-normal flex-shrink-0 ' to={formatLinkHTTPS(media?.website_link || media?.website)} target="_blank">
                  {media?.website || ''}
                </Link>
              </div>
            </div>
          </>)
        },
      },
      // {
      //   Header: t('Inventory'),
      //   accessor: "inventory_code",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 200,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const position = POSITION_INVENTORY_OPTIONS_LANG?.find((p) => p?.value === item?.position) || null;
      //     return (
      //       <>
      //         <div className="d-flex align-items-center" style={{ width: '190px' }}>
      //           <div className="flex-shrink-0 me-2 position-relative">
      //             <SVGImageDefault style={{ height: '48px' }} />
      //             {!!item?.is_main ? <></> : <span className="position-absolute text-primary fs-14 text-uppercase" style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: '100%', textAlign: 'center' }}>{t('Sub')}</span>}
      //           </div>
      //           <div>
      //             <div className="ms-2 fs-12 text-muted">{AD_PLATFORM_INVENTORY_OPTIONS_LANG?.find((op: any) => String(op?.value) === String(item?.ad_platform))?.label}</div>
      //             <strong className="text-muted ms-2">{item?.width || ''} * {item?.height || ''}</strong>
      //             {(String(item?.inventory_ad_type) === AD_TYPE_INVENTORY_IS_FIXED_BANNER) ? <></> : <TooltipCustom
      //               title={`(${t('Position')}, ${t('Margin Left')}, ${t('Margin Right')}, ${t('Margin Bottom')})`}
      //               className="d-inline-block vertical-align-middle"
      //             >
      //               <div className="ms-2 fs-12 text-muted">({position?.label || ''}, {String(item?.margin_left ?? '').replace(/px$/, '')}, {String(item?.margin_right ?? '').replace(/px$/, '')}, {String(item?.margin_bottom ?? '').replace(/px$/, '')})</div>
      //             </TooltipCustom>}
      //           </div>
      //         </div>
      //       </>
      //     )
      //   },
      // },
      // {
      //   Header: t('WEB_banner_size'),
      //   accessor: "banner_size",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 100,
      //   thClass: 'text-center',
      //   Cell: (cell: any) => {
      //     return (
      //       <>
      //         <div className="text-center" style={{ minWidth: '70px' }}>
      //           {cell?.value ? <strong className="text-muted">{String(cell?.value)?.split('*').join(` * `)}</strong> : ''}
      //         </div>
      //       </>
      //     )
      //   },
      // },
      // {
      //   Header: t('Ad Info'),
      //   accessor: "ad_info",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 170,
      //   thClass: 'text-start',
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (
      //       <div className="text-start fs-12" style={{ minWidth: '160px' }}>
      //         <div className="text-muted">{t('Tracking Code')}: <span>{item?.tracking_code || ''}</span></div>
      //         <div className="text-muted text-uppercase">{t('Ad ID')}: <span>{item?.ad_id || ''}</span></div>
      //         {String(item?.ad_platform) === AD_PLATFORM_INVENTORY_TYPE_DIGITAL_CAMP ? <div className="text-muted">{t('Campaign ID')}: <span>{item?.campaign_id}</span></div> :
      //           <div className="text-muted">{t('Sub ID')}: <span>{item?.sub_id || ''}</span></div>}
      //       </div>
      //     )
      //   },
      // },
      // {
      //   Header: 'CDN ' + t('Domain'),
      //   accessor: "cdn_domain",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 160,
      //   thClass: 'text-start',
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (
      //       <div className="text-start" style={{ minWidth: '140px' }}>
      //         <Link className='text-normal flex-shrink-0 ' to={formatLinkHTTPS(item?.cdn_domain)} target="_blank">
      //           {item?.cdn_domain}
      //         </Link>
      //       </div>
      //     )
      //   },
      // },
      // {
      //   Header: t('Ad Type'),
      //   accessor: "inventory_ad_type",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 130,
      //   thClass: 'text-center',
      //   Cell: (cell: any) => {
      //     return (
      //       <div className="text-center" style={{ minWidth: '100px' }}>
      //         <span>{AD_TYPE_INVENTORY_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(cell?.value))?.label}</span>
      //       </div>
      //     )
      //   },
      // },
      {
        Header: t('Device'),
        accessor: "device",
        filterable: true,
        sortable: false,
        thWidth: 70,
        Cell: (cell: any) => (
          <>
            <div style={{ minWidth: '70px' }}>{DEVICE_OPTIONS_LANG?.filter((item) => (!!cell?.value && String(item?.value) === String(cell?.value)))[0]?.label || cell?.value || '-'}</div>
          </>
        ),
      },
      // {
      //   Header: t('Device ID'),
      //   accessor: "device_id",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 100,
      //   Cell: (cell: any) => (
      //     <>
      //       <div style={{ minWidth: '70px' }}>{cell?.value}</div>
      //     </>
      //   ),
      // },
      {
        Header: t('Platform'),
        accessor: "platform",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => (
          <>
            <div style={{ minWidth: '90px' }}>{PLATFORM_LOG_OPTIONS_LANG?.filter((item) => (!!cell?.value && String(item?.value) === String(cell?.value)))[0]?.label || cell?.value || '-'}</div>
          </>
        ),
      },
      {
        Header: t('OS'),
        accessor: "os",
        filterable: true,
        sortable: false,
        thWidth: 90,
        Cell: (cell: any) => (
          <>
            <div style={{ minWidth: '80px' }}>{cell?.value || '-'}</div>
          </>
        ),
      },
      {
        Header: t('Browser'),
        accessor: "browser",
        filterable: true,
        sortable: false,
        thWidth: 90,
        Cell: (cell: any) => (
          <>
            <div style={{ minWidth: '80px' }}>{cell?.value || '-'}</div>
          </>
        ),
      },

      {
        Header: t('Created at'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'text-end',
        Cell: (cell: any) => {
          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{String(cell?.value || '').split('T')[0] || ''}</span> <br /> <span className="text-secondary">{String(String(cell?.value || '').split('T')[1]).split('.')[0] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Action'),
        thClass: 'text-center',
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div style={{ minWidth: '100px' }}>
              <ul className="list-inline flex-wrap justify-content-center align-items-center hstack gap-2 mb-0">
                <li className="list-inline-item me-0" id={`detail-log-${item?.id}`} >
                  <Link className="btn btn-sm btn-soft-secondary edit-item-btn" to="#" style={{ width: '90px' }}
                    onClick={(e) => { e.preventDefault(); handlePreviewTrackingLog(item) }}
                  >
                    {t('Button Detail')}
                  </Link>
                </li>
              </ul>
            </div>
          );
        },
      },
    ],
    [i18n?.language, JSON.stringify(listMedia)]
  );

  const handleChangePicker = (value: Date | null) => {
    setDateSearch((_prev) => value ? moment(new Date(value)).format("Y-MM-DD") : '');
  }

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy, page: 1 });
    });
  }, []);

  const handleDownloadExcel = async () => {
    try {
      setIsLoadingExportFile((_prev) => true);
      // const response: any = await downloadExcelTrackingLogs({ ...query, is_export: 1 });
      // if (response?.data) {
      //   setIsLoadingExportFile((_prev) => false);
      //   const link = document.createElement('a');
      //   link.href = response?.data;
      //   link.download = 'campaign';
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // } else {
      //   setIsLoadingExportFile((_prev) => false);
      //   toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      // }
    } catch (error: any) {
      setIsLoadingExportFile((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        setIsCallAllOptionLoading((_prev) => true);
        const [resMedia]: any = await Promise.all([getAllMedias()]);
        setIsCallAllOptionLoading((_prev) => false);

        const _listMedia = (resMedia?.data || [])?.map((item: any) => ({
          label: item?.name || '',
          value: `${item?.id || ''}`
        }));

        setListMedia((_prev) => _listMedia);
        setMediaSearch((_prev) => {
          const items = _listMedia?.filter((item: any) => String(query?.media_id || '')?.split(',')?.includes(String(item?.value || ''))) || [];
          return items;
        });

      } catch (error: any) {
        setIsCallAllOptionLoading((_prev) => false);
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  useEffect(() => {
    // if (platformSearch) {
    //   setPlatformSearch((_prev: any) =>
    //     PLATFORM_LOG_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    // if (adPlatformSearch) {
    //   setAdPlatformSearch((_prev: any) =>
    //     AD_PLATFORM_INVENTORY_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    if (adTypeSearch) {
      setAdTypeSearch((_prev: any) =>
        AD_TYPE_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
      );
    }

    if (deviceSearch) {
      setDeviceSearch((_prev: any) =>
        DEVICE_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
      );
    }

    // if (botSearch) {
    //   setBotSearch((_prev: any) =>
    //     BOT_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    if (browserSearch) {
      setBrowserSearch((_prev: any) =>
        BROWSER_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
      );
    }

    if (osSearch) {
      setOsSearch((_prev: any) =>
        OS_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
      );
    }

    // if (clickTypeSearch) {
    //   setClickTypeSearch((_prev: any) =>
    //     CLICK_TYPE_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    // if (referralTypeSearch) {
    //   setReferralTypeSearch((_prev: any) =>
    //     REFERRAL_TYPE_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    // if (versionSearch) {
    //   setVersionSearch((_prev: any) =>
    //     VERSION_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    // if (adTypeInventorySearch) {
    //   setAdTypeInventorySearch((_prev: any) =>
    //     AD_TYPE_INVENTORY_OPTIONS_LANG?.filter((e: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(e.value)))
    //   );
    // }

    // if (inventorySearch) {
    //   setInventorySearch((_prev: any) => {
    //     const items = listInventory?.filter((item: any) => _prev?.map((i: any) => String(i?.value))?.includes(String(item.code))) || [];
    //     return items?.map((item: any) => ({
    //       label: item?.name ? `[${!!item?.parent_code ? t('Main') : t('Sub')}] ${item?.name || ''} (${(item?.width || 0) + '*' + (item?.height || 0)})` : '',
    //       value: `${item?.code || ''}`
    //     })) || [];
    //   });
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    document.title = `${t('Log')} - ${t('Statistics')} | PressAi`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Log')} pageTitle={t('Statistics')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.LOG, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-5 col-sm-6 col-md-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t('Total')}:</span>
                            {(isTrackingLogLoading && query?.page === 1) ? <Spinner className="text-primary" style={{ width: '23px', height: '23px' }}></Spinner> : (<CountUp
                              start={0}
                              end={trackingLogs?.total || 0}
                              duration={1}
                              className="text-primary h4"
                            />)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-7  col-sm-6 col-md-6 text-end">
                        {/* <button
                          type="button"
                          className="btn btn-success"
                          onClick={handleDownloadExcel}
                          disabled={isLoadingExportFile}
                        >
                          {isLoadingExportFile ? <Spinner size="sm" ></Spinner> : <i className="ri-download-line align-bottom"></i>}
                          <span className="ms-1">{t('Button Download Excel')}</span>
                        </button> */}
                      </div>
                    </Row>

                  </CardHeader>
                  <CardBody className="border border-dashed border-end-0 border-start-0 card-body px-0 py-0">
                    <CollapseFilter>
                      <div className="d-flex flex-column g-4 align-items-start align-items-md-start">
                        <div className="w-100">
                          <Row className="g-4 align-items-center mb-0 mb-sm-2 mt-2">
                            <Col sm={6} md={3} lg={3} className='mt-3 mt-md-2'>
                              <LabelWrapper label={t('WEB_ad_type')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={AD_TYPE_OPTIONS_LANG}
                                  placeholder={`${t("WEB_ad_type")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={adTypeSearch || null}
                                  onChangeSelect={(e: any) => setAdTypeSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Log Type'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col>
                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-2'>
                              <LabelWrapper label={t('Media Type')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={TYPE_MEDIA_OPTIONS_LANG}
                                  placeholder={`${t("Media Type")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={addTypeSearch || null}
                                  onChangeSelect={(e: any) => setAddTypeSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}
                            <Col sm={6} md={3} lg={3} className='mt-3 mt-md-2'>
                              <LabelWrapper label={t('Medias')} isShow={true}>
                                <DropdownMultiOption
                                  name="medias"
                                  dataList={listMedia}
                                  initialValue={mediaSearch}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  placeholder={t('Medias')}
                                  onChangeSelect={(event: any) => {
                                    setMediaSearch((_prev) => event);
                                  }}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col sm={6} md={3} lg={3} className='mt-3 mt-md-2 '>
                              <LabelWrapper label={t('Time')} isShow={true}>
                                <DropdownOption
                                  name=""
                                  dataList={TIME_OPTION_LANG}
                                  placeholder={`${t("Time")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={timeSearch || null}
                                  onChangeSelect={(e: any) => setTimeSearch(e)}
                                  isHasOptionAll={true}
                                  optionAll={{ label: t('All'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col sm={6} md={3} className="mt-3 mt-md-2 date-picker-wrapper-custom">
                              <LabelWrapper label={t('Date')} isShow={!!dateSearch}>
                                <DatePicker
                                  className="form-control search"
                                  placeholderText={`${t('Date')}...`}
                                  value={dateSearch || ''}
                                  selected={dateSearch ? new Date(dateSearch) : null}
                                  dateFormat="yyyy-MM-dd"
                                  isClearable={true}
                                  locale={i18n?.language === 'ko' ? 'ko' : 'en'}
                                  onChange={handleChangePicker}
                                />
                              </LabelWrapper>
                            </Col>
                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Platform')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={PLATFORM_LOG_OPTIONS_LANG}
                                  placeholder={`${t('Platform')}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={platformSearch || null}
                                  onChangeSelect={(e: any) => setPlatformSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Platform'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3  mt-md-3'>
                              <LabelWrapper label={t('Ad Platform')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={AD_PLATFORM_INVENTORY_OPTIONS_LANG}
                                  placeholder={`${t("Ad Platform")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={adPlatformSearch || null}
                                  onChangeSelect={(e: any) => setAdPlatformSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Ad Platform'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            <Col sm={6} md={3} lg={3} className='mt-3'>
                              <LabelWrapper label={t('WEB_os')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={OS_OPTIONS_LANG}
                                  placeholder={`${t("WEB_os")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={osSearch || null}
                                  onChangeSelect={(e: any) => setOsSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All OS'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col>
                            <Col sm={6} md={3} lg={3} className='mt-3'>
                              <LabelWrapper label={t('WEB_browser')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={BROWSER_OPTIONS_LANG}
                                  placeholder={`${t("WEB_browser")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={browserSearch || null}
                                  onChangeSelect={(e: any) => setBrowserSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Browser'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Device')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={DEVICE_OPTIONS_LANG}
                                  placeholder={`${t("Device")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={deviceSearch || null}
                                  onChangeSelect={(e: any) => setDeviceSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Device'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col sm={6} md={3} lg={3} className='mt-3'>
                              <LabelWrapper label={t('WEB_device_id')} isShow={!!deviceIdSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('WEB_device_id')}...`}
                                  value={deviceIdSearch}
                                  onChange={(e) => setDeviceIdSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col sm={6} md={3} lg={3} className='mt-3'>
                              <LabelWrapper label={t('IP')} isShow={!!ipSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('IP')}...`}
                                  value={ipSearch}
                                  onChange={(e) => setIpSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col sm={6} md={3} lg={3} className='mt-3'>
                              <LabelWrapper label={t('UUID')} isShow={!!uuidSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('UUID')}...`}
                                  value={uuidSearch}
                                  onChange={(e) => setUuidSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Referral Type')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={REFERRAL_TYPE_OPTIONS_LANG}
                                  placeholder={`${t("Referral Type")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={referralTypeSearch || null}
                                  onChangeSelect={(e: any) => setReferralTypeSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Referral Type'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}
                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Inventory Type Of Inventory In Filter')} isShow={true}>
                                <DropdownMultiOption
                                  name="inventory_type"
                                  dataList={listTypeInventory?.map((item) => ({ value: String(item?.id), label: item?.title })) || []}
                                  placeholder={`${t('Inventory Type Of Inventory In Filter')}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={typeInventorySearch || null}
                                  onChangeSelect={(e: any) => setTypeInventorySearch(e)}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Inventory')} isShow={true}>
                                <DropdownInventory
                                  name="inventories"
                                  isMulti={true}
                                  dataList={!!mediaSearch?.length ? listInventory?.filter((inv: any) => (mediaSearch?.map((m: any) => String(m?.code)))?.includes(String(inv?.media?.code))) : listInventory}
                                  initialValue={inventorySearch}
                                  placeholder={t('Inventory')}
                                  onChangeSelect={(event: any) => {
                                    setInventorySearch((_prev) => event);
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3 '>
                              <LabelWrapper label={t('WEB_bot')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={BOT_OPTIONS_LANG}
                                  placeholder={`${t("WEB_bot")}...`}
                                  className="search-filter-category-type dropdown-status-rounded "
                                  classNamePrefix="name-prefix"
                                  initialValue={botSearch || null}
                                  onChangeSelect={(e: any) => setBotSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Type Bot'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}
                            <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('WEB_reference_link')} isShow={!!referenceLinkSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('WEB_reference_link')}...`}
                                  value={referenceLinkSearch}
                                  onChange={(e) => setReferenceLinkSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>
                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('WEB_banner_size')} isShow={!!bannerSizeSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('WEB_banner_size')}...`}
                                  value={bannerSizeSearch}
                                  onChange={(e) => setBannerSizeSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}
                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Ad Type')} isShow={true}>
                                <DropdownMultiOption
                                  name="inventory_ad_type"
                                  dataList={AD_TYPE_INVENTORY_OPTIONS_LANG}
                                  placeholder={`${t('Ad Type')}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={adTypeInventorySearch || null}
                                  onChangeSelect={(e: any) => setAdTypeInventorySearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Type'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Version')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={VERSION_OPTIONS_LANG}
                                  placeholder={`${t("Version")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={versionSearch || null}
                                  onChangeSelect={(e: any) => setVersionSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Version'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}
                            <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('Keyword')}...`}
                                  value={keywordSearch}
                                  onChange={(e) => setKeywordSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>
                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Tracking Code')} isShow={!!trackingCodeSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('Tracking Code')}...`}
                                  value={trackingCodeSearch}
                                  onChange={(e) => setTrackingCodeSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 mt-md-3'>
                              <LabelWrapper label={t('Sub ID')} isShow={!!subIdSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('Sub ID')}...`}
                                  value={subIdSearch}
                                  onChange={(e) => setSubIdSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3'>
                              <LabelWrapper label={t('Ad ID')} isShow={!!adIdSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('Ad ID')}...`}
                                  value={adIdSearch}
                                  onChange={(e) => setAdIdSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}
                            <Col sm={6} md={3} lg={3} className='mt-3 order-3 order-md-0'>
                              <LabelWrapper label={t('Title Post')} isShow={!!titleSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('Title Post')}...`}
                                  value={titleSearch}
                                  onChange={(e) => setTitleSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>
                            <Col sm={6} md={6} lg={6} className='mt-3 order-3 order-md-0'>
                              <LabelWrapper label={t('Url')} isShow={!!urlSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('Url')}...`}
                                  value={urlSearch}
                                  onChange={(e) => setUrlSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>


                            {/* <Col sm={6} md={3} lg={3} className='mt-3 order-2 order-md-0'>
                              <LabelWrapper label={t('UUID')} isShow={!!uuidSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('UUID')}...`}
                                  value={uuidSearch}
                                  onChange={(e) => setUuidSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}



                            {/* <Col sm={6} md={3} lg={3} className='mt-3 order-2 order-md-0'>
                              <LabelWrapper label={t('WEB_duid')} isShow={!!duidSearch}>
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t('WEB_duid')}...`}
                                  value={duidSearch}
                                  onChange={(e) => setDuidSearch(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 order-1 order-md-0'>
                              <LabelWrapper label={t('Monitor Type')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={MONITOR_TYPE_OPTIONS_LANG}
                                  placeholder={`${t("Monitor Type")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={monitorTypeSearch || null}
                                  onChangeSelect={(e: any) => setMonitorTypeSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All'), value: '' }}
                                  isShowIcon={true}
                                  icons={ICONS}
                                />
                              </LabelWrapper>
                            </Col> */}

                            {/* <Col sm={6} md={3} lg={3} className='mt-3 order-1 order-md-0'>
                              <LabelWrapper label={t('Click Type')} isShow={true}>
                                <DropdownMultiOption
                                  name=""
                                  dataList={CLICK_TYPE_OPTIONS_LANG?.filter((item: any) => [CLICK_TYPE_NORMAL, CLICK_TYPE_FORCE]?.includes(item?.value))}
                                  placeholder={`${t("Click Type")}...`}
                                  className="search-filter-category-type dropdown-status-rounded"
                                  classNamePrefix="name-prefix"
                                  initialValue={clickTypeSearch || null}
                                  onChangeSelect={(e: any) => setClickTypeSearch(e)}
                                  isHasOptionAll={false}
                                  cacheOptions={true}
                                  optionAll={{ label: t('All Click Type'), value: '' }}
                                />
                              </LabelWrapper>
                            </Col> */}

                            <Col sm={12} md={3} lg={3} className="hstack gap-1 justify-content-center justify-content-sm-end mt-4 mt-md-3 order-3 order-md-0">
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-primary me-2 "
                                  onClick={searchData}
                                  disabled={(isTrackingLogLoading || isCallAllOptionLoading)}
                                >
                                  {(isTrackingLogLoading) ? <div className="me-1" style={{ display: 'inline-table', verticalAlign: 'top' }}><Spinner size="sm" style={{ width: '14px', height: '14px' }}></Spinner></div> : <i className="ri-search-line align-bottom me-1"></i>}{" "}
                                  {t('Button Search')}
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-secondary fs-14"
                                  onClick={resetData}
                                >
                                  <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                  {t('Button Reset')}
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </CollapseFilter>
                  </CardBody>
                  <CardBody className="pt-0 px-0">
                    <div>
                      <InfiniteScroll
                        dataLength={trackingLogs?.list?.length || 0}
                        next={handleLoadMore}
                        scrollableTarget='scrollableDiv'
                        hasMore={trackingLogs && trackingLogs?.list?.length < trackingLogs?.total ? true : false}
                        loader={''} // loader={<LoadingListNotify />}
                        scrollThreshold={'50%'}
                      >
                        <div className="mx-3 my-4 mt-3">
                          <TableContainer
                            className="custom-header-css"
                            divClass="table-responsive table-card"
                            tableClass="align-middle table-bordered-dashed sticky-table-tracking-log"
                            theadClass="table-light text-muted"
                            columns={columns}
                            data={trackingLogs?.list?.length ? trackingLogs?.list : []}
                            customPageSize={query.limit}
                            customPageIndex={query.page - 1}
                            totalRecords={trackingLogs?.total}
                            customPageCount={1}
                            handleChangePage={handleChangePage}
                            manualSorting={true}
                            sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                            handleChangeSorting={handleChangeSorting}
                            isLoading={isTrackingLogLoading}
                            isShowPagination={false}
                            isShowLoadingBottom={query.page > 1}
                            isScrollToTop={false}
                          />
                        </div>
                      </InfiniteScroll>
                    </div>
                    <ToastContainer closeButton={false} limit={1} />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
        <Modal isOpen={!!previewTrackingLog} centered={true} size="xl" scrollable={true} toggle={onClosePreviewTrackingLogClick} keyboard={true}>
          <ModalHeader toggle={onClosePreviewTrackingLogClick}>
            {t('Detail Log')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col md={12}>
                <div>
                  <div className="row g-3">
                    <Col xxl={12} className="mt-0">
                      <TableTracking data={previewTrackingLog} />
                    </Col>
                    <div className="col-lg-12">
                      <div className="hstack gap-2 justify-content-end">
                        <button className="btn btn-soft-secondary fs-14" type="button" color="light" onClick={onClosePreviewTrackingLogClick}>
                          <i className="ri-indeterminate-circle-line align-bottom me-1"></i>
                          {t('Button Close')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >
      </div >
    </React.Fragment >
  );
};

export default TrackingLog;
